import React from "react";
import ReactDOM from "react-dom";
import styles from "./Modal.css";

// Referenced from https://reactjs.org/docs/portals.html
class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
  }

  componentDidMount() {
    document
      .getElementById("body")
      .appendChild(this.el)
      .classList.add(styles["modal-backdrop"]);
  }

  componentWillUnmount() {
    document.getElementById("body").removeChild(this.el);
  }

  render() {
    return ReactDOM.createPortal(this.props.children, this.el);
  }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Common/Modal/Modal.js